export const getEligibilityCheckPath = ({ isPartnerCourse, params }) => {
  if (isPartnerCourse) {
    const { lms_course_id, ...query_params } = params;

    return Routes.check_user_eligibility_partner_lms_course_signup_path(lms_course_id, { ...query_params });
  } else {
    return Routes.signup_check_user_eligibility_path({...params});
  }
};

export const getBulkEligibilityCheckPath = ({ isPartnerCourse, params }) => {
  if (isPartnerCourse) {
    const { lms_course_id, ...query_params } = params;

    return Routes.bulk_check_user_eligibility_partner_lms_course_signup_path(lms_course_id, { ...query_params });
  } else {
    return Routes.signup_bulk_check_user_eligibility_path({...params});
  }
};
